import toast from 'react-hot-toast'
import type { ToastOptions } from 'react-hot-toast'
import {
  getAlertToastOptions,
  type AlertToastSeverity,
} from './alertToastStyles'

const show = (
  severity: AlertToastSeverity,
  message: string,
  options?: ToastOptions
) => {
  const toastFn =
    severity === 'loading'
      ? toast.loading
      : severity === 'error'
        ? toast.error
        : toast.success

  return toastFn(message, getAlertToastOptions(severity, options))
}

export const showAlertToast = {
  success: (message: string, options?: ToastOptions) =>
    show('success', message, options),
  error: (message: string, options?: ToastOptions) =>
    show('error', message, options),
  info: (message: string, options?: ToastOptions) =>
    toast(message, getAlertToastOptions('info', options)),
  warning: (message: string, options?: ToastOptions) =>
    toast(message, getAlertToastOptions('warning', options)),
  loading: (message: string, options?: ToastOptions) =>
    show('loading', message, options),
}

export { getAlertToastOptions }
